import { Box, KdsBadge, KdsText, VStack } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { type CatalogMediumBlocProps } from "./CatalogMediumBloc.types";

export const CatalogMediumBloc = ({ sandboxItem }: CatalogMediumBlocProps) => {
  const { t } = useTranslate();

  if (
    !sandboxItem.catalogMedium ||
    sandboxItem.name === sandboxItem.catalogMedium.name
  ) {
    return null;
  }

  return (
    <Box rounded="br-lg" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <KdsText as="h2" size="title-sm">
          {t("orderItemSummary.selectedProduct.title")}
        </KdsText>
        <KdsBadge>{sandboxItem.catalogMedium.name || ""}</KdsBadge>
      </VStack>
    </Box>
  );
};
